import { Button, Divider } from "@mui/material";
import { Select, MenuItem } from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import "react-quill/dist/quill.snow.css"; // Import Quill styles
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { useDataLayerValue } from "../../DataLayer/DataLayer";
import { checkPackagePages, duplicateShipMobilePage } from "../../utils/ApiCalls/AddShipMobilePage";
import { addlog, addBulkLogs } from "../../utils/ApiCalls/Logs";
import FormPopup from "../FormPopup";
import {
  getSailingPageData,
} from "../../utils/ApiCalls/SailingData";
import { getSailingDate } from "../../utils/ApiCalls/SailingDates";
import { getVessels } from "../../utils/ApiCalls/SpecialPage";
import { checkFields } from "../../utils/Validation/checkFields";
import { SAILING_PAGE_LOG_TYPES } from "../../constants/logging";

const SailingPageDuplicateInput = ({ newsletter }) => {
  const [oldsailingDate, setOldSailingDate] = useState();
  const [sailing_date, setSailingDate] = useState();
  const params = useParams();
  const [vessel_id, setVessel_id] = useState();
  const [selectedPlanner, setSelectedPlanner] = useState("");
  const [displayLocation, setDisplayLocation] = useState([]);
  const [{ userDetails }, dispatch] = useDataLayerValue();
  const [error, setError] = useState();
  const [vesselOptions, setVesselOptions] = useState([]);
  const [sailingOptions, setsailingOptions] = useState([]);
  const [availablePages, setAvailablePage] = useState([]);
  const [isPagesInPackageId ,setIsPagesInPackageId] = useState(false)
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [matchedCount, setMatchedCount] = useState(0);
  const [pagesTitles,setPagesTitles] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    getOptionLocation();
  }, []);


  const compareFromat = (date) => {
    return moment(date).format("DDMMYYYY");
  };
  const addNewsLetter = async (e) => {
    e.preventDefault();
    
    const result = await checkPackagePages(newsletter?.package_id, selectedPlanner);
    setIsPagesInPackageId(result?.matchedCount > 0 || false);
    setPagesTitles(result?.matchedTargetPages || []);
    setMatchedCount(result?.matchedCount || 0);
    if (result?.matchedCount > 0) {
      setShowConfirmModal(true);
      dispatch({
        type: "SET_LOADING",
        loading: false,
      });
      return;
    }
    
    await handleSubmit();
  };

  const handleSubmit = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let added = false;
    let dataValues = {
      sailing_date,
      duration: sailingOptions.find(
        (item) =>
          compareFromat(item.sailing_date) == compareFromat(sailing_date)
      )?.cruisePackage.duration,
      package_id: sailingOptions.find(
        (item) =>
          compareFromat(item.sailing_date) == compareFromat(sailing_date)
      )?.cruisePackage.package_id,
      vessel_id: newsletter?.vessel_id,
      page_count: newsletter?.page_count,
    };

    let valid = checkFields(dataValues);
    if (valid) {
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: valid, type: "error" },
      });
      dispatch({
        type: "SET_LOADING",
        loading: false,
      });
      setError(valid);
      return;
    } else {
      setError();

      let data = await duplicateShipMobilePage({
        old_package_id: newsletter?.package_id,
        vessel_id: newsletter?.vessel_id,
        package_id: selectedPlanner,
      });

      if (data?.error) {
        dispatch({
          type: "SET_ERROR_MESSAGE",
          errMess: { message: data.error, type: "error" },
        });
        return;
      } else {
        added = true;
        const vesselName = vesselOptions.find(v => v.id === newsletter?.vessel_id)?.name || "Unknown Vessel";
        const targetPackage = availablePages.find(p => p.package_id === selectedPlanner);
        await addlog(
          SAILING_PAGE_LOG_TYPES.ACTIONS.CONTENT_DUPLICATED,
          SAILING_PAGE_LOG_TYPES.MODULE,
          {
            title: `Sailing content duplicated from ${newsletter?.package_id} to ${selectedPlanner}`,
            source_package_id: newsletter?.package_id,
            target_package_id: selectedPlanner,
            vessel_id: newsletter?.vessel_id,
            vessel_name: vesselName,
            page_count: newsletter?.page_count,
            source_sailing_date: newsletter?.sailing_date,
            target_sailing_date: targetPackage?.sailing_date,
            duration: newsletter?.duration
          },
          userDetails.id
        );
      }

      navigate(`/shore/cruise-page/${params.vessel}`);
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { 
          message: `Sailing content duplicated successfully`, 
          type: "success" 
        },
      });
    }
  };

  const getOptionLocation = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });

    let vessels = await getVessels();
    let data = await getSailingPageData({
      vessel_id: newsletter.vessel_id,
      // duration: newsletter.duration,
      // page_count: "all",
      targetSailing: true,
      status: "draft",
      sort:'sailing_date'
    });
    if (vessels.error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: vessels.error,
      });
    } else {
      setAvailablePage(data?.data);
      setVesselOptions(vessels);
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  useEffect(() => {
    if (newsletter) {
      getSailingDates();
      setOldSailingDate(newsletter?.sailing_date);
      setVessel_id(newsletter?.vessel_id);
    }
  }, [newsletter]);
  const getSailingDates = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let data = await getSailingDate({
      page: 1,
      limit: 2000,
      vessel_id: newsletter?.vessel_id,
    });
    setsailingOptions(data?.data);
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  return (
    <div>
      <section className="content">
        {error && (
          <div className="d-flex justify-content-center align-items-center text-danger">
            <p>{error}</p>
          </div>
        )}

        <div className="container-fluid">
          <div className="card">
            <form className="input_form" onSubmit={addNewsLetter}>
              <div style={{ padding: "10px" }} className="card-body">
                <h4 style={{ fontWeight: "bold" }}>
                  Duplicate Sailing content
                </h4>
                <p>
                  {
                    vesselOptions.find(
                      (item) => item.id === newsletter?.vessel_id
                    )?.name
                  }{" "}
                  - {moment(oldsailingDate).format("DD-MMMM-YYYY")}
                </p>
              </div>
              <div style={{ paddingLeft: "10px", paddingRight: "10px" }}>
                <Divider style={{ border: "1px solid gray" }} />

                <div className="row" style={{ marginTop: "20px" }}>
                  <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                    <h4 style={{ fontWeight: "bold" }}>Source Sailing</h4>
                    <p>This sailing content will be copied</p>
                    <div
                      style={{
                        border: "1px solid black",
                        padding: "20px",
                        marginTop: "20px",
                        height: "300px",
                        marginBottom: "20px",
                      }}
                    >
                      <p style={{ fontWeight: "bold" }}>
                        {" "}
                        {
                          vesselOptions.find(
                            (item) => item.id == newsletter?.vessel_id
                          )?.name
                        }
                      </p>
                      <p style={{ marginBottom: "20px" }}>
                        {" "}
                        Duration: {newsletter?.duration} Days
                      </p>
                      <p> Assigned Pages: {newsletter?.page_count}</p>
                      <p> Status: {newsletter?.status}</p>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                    <h4 style={{ fontWeight: "bold" }}>Target Sailing</h4>
                    <p>Select future sailings to copy content to</p>
                    <div
                      style={{
                        border: "1px solid black",
                        padding: "20px",
                        marginTop: "20px",
                        height: "300px",
                        marginBottom: "20px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div className="fieldrow" style={{ width: "100%" }}>
                        <label className="f_label">Target Sailing</label>
                        <Select
                          required
                          style={{ width: "100%", height: "45px" }}
                          value={selectedPlanner}
                          onChange={(e) => setSelectedPlanner(e.target.value)}
                        >
                          {availablePages.map((item, index) => {
                            const rawDuration = item?.duration ?? 0;
                            const duration = Math.abs(rawDuration);
                            return (
                              <MenuItem key={index + ""} value={item.package_id}>
                                {`${item.package_id} | ${moment(item?.sailing_date).format("DD MMM")} to ${moment(item?.end_date).format("DD MMM YYYY")} / ${duration} Nights`}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    padding: "10px",
                    border: "1px solid black",
                  }}
                >
                  <div style={{ flex: 1 }}>
                    <h4 style={{ fontWeight: "bold" }}>Target Sailing</h4>
                  </div>
                  <div className=" text-right" style={{ marginLeft: "10px" }}>
                    <Button
                      type="submit"
                      variant="contained"
                      className="btn main_submit"
                      disabled={!selectedPlanner}
                    >
                      Duplicate to Sailing
                    </Button>
                  </div>
                </div>
              </div>
            </form>
            <FormPopup
              open={showConfirmModal}
              setOpen={setShowConfirmModal}
              width="500px"
            >
              <div style={{ textAlign: "center" }}>
                <h4 style={{ fontWeight: "bold", marginBottom: "20px" }}>
                  Confirm Overwrite
                </h4>
                <p style={{ marginBottom: "30px", fontSize: "16px" }}>
                  The following {matchedCount} page{matchedCount !== 1 ? 's' : ''} in the target sailing overlap with the source sailing:<br />{" "}
                  <div style={{ maxHeight: "150px", overflowY: "auto", marginTop: "5px", textAlign: "left", paddingLeft: "20px" }}>
                    {pagesTitles.map((page, index) => (
                      <div key={page.id} style={{ marginTop: "5px" }}>
                        {index + 1}. {page.title}
                      </div>
                    ))}
                  </div>
                  <br />
                  Continuing will overwrite these pages with the corresponding pages from the source sailing. Would you like to proceed?
                </p>
                <div style={{ display: "flex", justifyContent: "center", gap: "15px" }}>
                  <Button
                    variant="contained"
                    onClick={() => {
                      setShowConfirmModal(false);
                      handleSubmit();
                    }}
                    style={{ backgroundColor: "#d32f2f", color: "white" }}
                  >
                    Yes, Continue
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={() => setShowConfirmModal(false)}
                    style={{ borderColor: "#666", color: "#666" }}
                  >
                    No, Cancel
                  </Button>
                </div>
              </div>
            </FormPopup>
          </div>
          <div className="pt-3"></div>
        </div>
      </section>
    </div>
  );
};

export default SailingPageDuplicateInput;
